import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-inactive-all',
  templateUrl: './inactive-all.component.html',
  styleUrls: ['./inactive-all.component.css']
})
export class InactiveAllComponent implements OnInit {

  @ViewChild('sidenav') sidenav: MatSidenav;

  screenWidth: number;
  constructor() {
    this.screenWidth = window.innerWidth;
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
    };
   }

  ngOnInit(): void {
  }

sideBarOpen = true;

  sideBarToggler() {
    this.sideBarOpen = !this.sideBarOpen;
  }

  

}
